<template>
  <div v-if="bid.id" class="container load-day-page">
    <loader-wrapper :loading="isLoading" text="Загрузка">
      <breadcrumb crumb="load-day" />
      <section class="container shipping_list">
        <el-row :gutter="24">
          <header-load-day :bid="bid" />

          <el-col :span="10">
            <additional-menu
              :bids-list-is-ready="!!responsesList.length"
              :current-day="currentDay"
              :bid="bid"
              @dialogSelectAutoVisible="dialogSelectAuto = true"
              @registry="dialogRegistry = true"
            />

            <bids-list-filter
              v-if="!isDispatcherRole"
              @update="updateFilterStatus"
            />
          </el-col>
        </el-row>
      </section>
      <div v-if="!isDispatcherRole" class="auto_list_component">
        <responses-in-progress
          :bid="bid"
          :list="responsesListInProgress"
          @accept="fetchResponsesLoad"
        />
      </div>

      <div class="auto_list_component">
        <responses
          :show-deleted-list="statusFilter === 3"
          :day="currentDay"
          :bid="bid"
          :status="statusFilter"
          :list="responsesList"
          :price-filter="priceFilter"
          :fetch="fetchResponses"
          :update-response="updateResponses"
          @updateDate="getBid"
          @filter="setPriceFilter"
        />
      </div>
      <el-dialog
        title="Отклик на заявку"
        :visible.sync="dialogSelectAuto"
        width="760px"
      >
        <driver-list
          v-if="dialogSelectAuto"
          :day="currentDay"
          :type="bid.type_code"
          :org-id="bid.org_client_id"
          @changed="updateState"
        />
      </el-dialog>
    </loader-wrapper>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

import AdditionalMenu from '@/views/LoadDay/Components/AdditionalMenu'
import BidsListFilter from '@/views/LoadDay/Components/Responses/Filters/BidsListFilter'
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb'
import DriverList from '@/components/Forms/DriverList'
import HeaderLoadDay from '@/views/LoadDay/Components/Header'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'
import Responses from '@/views/LoadDay/Components/Responses/Responses'
import ResponsesInProgress from '@/views/LoadDay/Components/Responses/ResponsesInProgres'

export default {
  name: 'LoadDay',
  components: {
    ResponsesInProgress,
    Responses,
    HeaderLoadDay,
    DriverList,
    BidsListFilter,
    AdditionalMenu,
    LoaderWrapper,
    Breadcrumb,
  },
  data() {
    return {
      dialogSelectAuto: false,
      dialogRegistry: null,
      statusFilter: null,
      priceFilter: {
        price_from_field_driver: undefined,
        price_from_storage_driver: undefined,
      },
    }
  },
  computed: {
    ...mapGetters({
      bid: 'loadDay/getBid',
      currentDay: 'loadDay/getCurrentLoadDay',
      getLoading: 'loadDay/getLoading',
      getResponses: 'loadDay/getResponses',
      getResponsesInProgress: 'loadDay/getResponsesInProgress',
    }),
    isLoading() {
      return this.getLoading()
    },
    responsesList() {
      return [null, 3].includes(this.statusFilter)
        ? this.getResponses
        : this.getResponses.filter(
            r =>
              this.statusFilter ===
              (r.master_approve_id !== null ? r['master-approve'].status : 0),
          )
    },
    responsesListInProgress() {
      return [null, 3].includes(this.statusFilter)
        ? this.getResponsesInProgress
        : this.getResponsesInProgress.filter(
            r =>
              this.statusFilter ===
              (r.master_approve_id !== null ? r['master-approve'].status : 0),
          )
    },
  },
  watch: {
    'currentDay.id'(val) {
      if (val) {
        this.priceFilter = {
          price_from_field_driver: undefined,
          price_from_storage_driver: undefined,
        }
        this.statusFilter = null
        this.fetchResponses()
      }
    },
  },
  created() {
    this.getBid()
  },
  methods: {
    ...mapActions('loadDay', [
      'fetchBid',
      'fetchResponsesInDay',
      'fetchResponsesUpdate',
    ]),
    ...mapMutations('loadDay', ['setUpdateResponse']),
    getBid() {
      const { bidId: bid_id, loadDayId } = this.$route.params
      const is_archive = 'ignore' // ignoring is archive or not

      if (bid_id && loadDayId) {
        this.fetchBid({ bid_id, loadDayId, is_archive })
      }
    },
    fetchResponses() {
      return this.fetchResponsesInDay({
        ...this.priceFilter,
        load_day_id: this.currentDay.id,
        is_deleted: this.statusFilter === 3 ? 1 : 0,
        'per-page': 200,
        expand: 'is_auto_and_driver_and_bid_client_org_already_were_together',
      })
    },
    updateResponses(data) {
      return this.setUpdateResponse(data)
    },
    fetchResponsesLoad() {
      return this.fetchResponsesUpdate({
        ...this.priceFilter,
        load_day_id: this.currentDay.id,
        is_deleted: this.statusFilter === 3 ? 1 : 0,
        'per-page': 200,
      })
    },
    setPriceFilter(filters) {
      this.priceFilter = { ...filters }
      this.fetchResponses()
    },
    openDialogRegistry(data) {
      this.dialogRegistry = data
    },
    updateState() {
      this.dialogSelectAuto = false
      this.fetchResponses()
    },
    updateFilterStatus(status) {
      const needToUpdate = [this.statusFilter, status].includes(3)

      this.statusFilter = status

      if (needToUpdate) {
        this.fetchResponses()
      }
    },
  },
}
</script>

<style lang="sass">
.load-day-page
  .shipping_list
    .shipping_card
      margin-bottom: 20px
      box-shadow: none
      &:hover
        transition: all 0.2s
        box-shadow: 0 2px 16px rgba(0, 0, 0, 0.12)
      .shipping_info
        padding: 0 10px 10px
        min-height: 150px
        .sh-span
          font-size: 14px
          .sh-comment
            color: #409EFF
            border-bottom: 1px solid
            cursor: pointer
        .progress-block
          margin-bottom: 5px
          p
            margin: 0 0 5px
            font-family: Tahoma, sans-serif
            font-size: 14px
            color: rgba(0, 0, 0, 0.47)
            span
              color: rgba(0, 0, 0, 0.81)
              &.capitalize
                text-transform: capitalize
          .el-progress
            position: absolute
            width: 100%
        .sh_dist
          display: flex
          flex-direction: column
          margin: 0 15px
          align-items: center
        .number_date
          font-size: 14px
          line-height: 17px
          color: rgba(0, 0, 0, 0.47)
          border-radius: 5px
          margin-bottom: 0
          &.green
            color: #00bf40
        .distance
          font-size: 24px
          line-height: 17px
          color: #000000
          display: flex
          align-items: center
          justify-content: flex-end
          margin: 10px 0
          img
            margin-right: 10px
        .d_h2
          font-size: 18px
          margin: 5px 0
        .time
          font-size: 14px
          line-height: 17px
          color: rgba(0, 0, 0, 0.47)
          border-radius: 5px
          margin: 0 0 15px 0
          span
            margin: 0 5px
        .shipping-row
          display: flex
          align-items: center
          p
            font-size: 12px
            line-height: 17px
            &.ri_p1
              color: rgba(0, 0, 0, 0.5)
            &.ri_p2
              color: #000000
        .shipping-h2
          margin-bottom: 0
          display: flex
          justify-content: center
        .shipping_info_right
          text-align: right
          .weight
            font-size: 14px
            line-height: 17px
            color: rgba(0, 0, 0, 0.7)
            border-radius: 5px
        .day-status
          font-size: 0.9em
          color: #f00 !important
        .day-report
          margin-left: 5px
          font-size: 0.9em
          color: #67C23A !important
  .preloader-space
    height: 200px
  .customer-price, .load-day-select
    font-size: 14px
    .customer-price
      margin-bottom: 30px
      margin-top: 5px
    .btn-dropdown.el-button--info.is-plain
      background-color: #fff
      font-weight: 300
      color: #BCBCBC
      border-color: #BCBCBC
    .el-dropdown-link
      cursor: pointer
      color: #409EFF
      .el-icon-arrow-down
        font-size: 12px
      .demonstration
        display: block
        color: #8492a6
        font-size: 14px
        margin-bottom: 20px
    .btn-dop-menu
      margin-bottom: 25px

    .bids-filter
      & > div
        text-align: right
        &:first-child .el-link
          margin-top: 20px
      & .el-link
        margin: 6px 0
        font-weight: 600
        border-bottom: 1px solid #409EFF
      & .el-link.el-link--success
        border-bottom: 1px solid #67C23A
    .bids-dop-menu
      & > div
        text-align: right

.load-day-status
  display: flex
  align-items: center
  &__status
    text-align: right
  &__btn
    margin-left: auto

.load-day-select
  .el-select
    max-width: 167px
.price-load-day
  p
    margin: 0 5px
  i
    font-size: 24px
    color: #d7d7d7
    &:hover
      color: #2ECC71
</style>
